import Client from './Client';
import {BreadcrumbType, ClientInitParams} from './types';

let client: Client | undefined;

const Bugsnag = {
  start: (params: ClientInitParams) => {
    if (client) {
      // eslint-disable-next-line no-console
      console.warn('Bugsnag.start() has already been called. Ignoring.');
      return;
    }
    client = new Client(params);
  },
  leaveBreadcrumb: (name: string, metaData: any, type: BreadcrumbType) => {
    if (!client) {
      // eslint-disable-next-line no-console
      console.warn('Bugsnag.leaveBreadcrumb() called before start().');
      return;
    }
    client.leaveBreadcrumb(name, metaData, type);
  },
  notify: (error: Error, metaData?: any) => {
    if (!client) {
      // eslint-disable-next-line no-console
      console.warn('Bugsnag.notify() called before start().');
      return;
    }
    client.notify(error, metaData);
  },
};

export default Bugsnag;
